import { Injectable } from "@angular/core";
import { DataService } from "../data.service";

@Injectable({
  providedIn: "root",
})
export class PreviusStudiesDigitizedService {
  constructor(private dataService: DataService) {}

  private readonly addPreviousStudiesDigitizedEndPoint: string =
    "/previousStudiesDigitized/addPreviousStudiesDigitized/";

  private readonly deletePreviousStudiesDigitizedEndPoint: string =
    "/previousStudiesDigitized/deletePreviousStudiesDigitized/";

  private readonly getPreviousStudiesDigitizedIdsByMedicalAppointmentIdEndPoint: string =
    "/previousStudiesDigitized/getPreviousStudiesDigitizedIdsByMedicalAppointmentId/";

  private readonly getPreviousStudiesDigitizedFileByIdEndPoint: string =
    "/previousStudiesDigitized/getPreviousStudiesDigitizedFileById/";

  private readonly getPreviousStudiesLinksByMedicalAppointmentIdEndPoint: string =
    "/previousStudiesDigitized/getPreviousStudiesLinksByMedicalAppointmentId/";

  async getPreviousStudiesLinksByMedicalAppointmentId(
    medicalAppointmentId: number
  ): Promise<string[]> {
    const params = { medicalAppointmentId };
    return await this.dataService
      .get<string[]>(
        this.getPreviousStudiesLinksByMedicalAppointmentIdEndPoint,
        params
      )
      .toPromise();
  }

  async addPreviousStudiesDigitized(
    medicalAppointmentId: number,
    fileBase64: string
  ): Promise<boolean> {
    const params = { medicalAppointmentId, fileBase64 };
    return await this.dataService
      .post<boolean>(this.addPreviousStudiesDigitizedEndPoint, params)
      .toPromise();
  }

  async deletePreviousStudiesDigitized(id: number): Promise<boolean> {
    const params = { id };
    return await this.dataService
      .post<boolean>(this.deletePreviousStudiesDigitizedEndPoint, params)
      .toPromise();
  }

  async getPreviousStudiesDigitizedIdsByMedicalAppointmentId(
    medicalAppointmentId: number
  ): Promise<number[]> {
    const params = { medicalAppointmentId };
    return await this.dataService
      .get<number[]>(
        this.getPreviousStudiesDigitizedIdsByMedicalAppointmentIdEndPoint,
        params
      )
      .toPromise();
  }

  async getPreviousStudiesDigitizedFileById(id: number): Promise<string> {
    const params = { id };
    return await this.dataService
      .get<string>(this.getPreviousStudiesDigitizedFileByIdEndPoint, params)
      .toPromise();
  }
}
